<template>
  <scroll-center-dialog v-model="opened" :loading="save_loading" @close="close" @apply="save" :title="form_title" :scrolled="false">
    <span v-if="edit">
      <v-row no-gutters class="text-left mt-4">
        <v-col cols="6" md="4" class="text-h6">Пользователь:</v-col>
        <v-col cols="6" md="8" class="text-h6">{{ chat.user }}</v-col>
      </v-row>
      <v-divider class="primary mb-3"></v-divider>
    </span>
    <span v-else>
      <loading-autocomplete
          class="mb-n4 mt-4"
          placeholder="Введите ФИО и выберете из предложенных вариантов"
          label="Пользователь"
          outlined
          v-model="chat.user"
          search-parameter="fio"
          :load-fios="false"
          :url="user_selector"
          :error="hasError('user')"
          :errorMessages="getError('user')"
      >
        <template v-slot:no-data>
          <div>
            Для поиска начните набирать ФИО, <br> и подождите 1 секунду, либо нажмите Enter
          </div>
        </template>
      </loading-autocomplete>
      <v-text-field
          outlined
          class="mb-n4"
          v-model="chat.chat_id"
          label="Id чата"
          :error="hasError('chat_id')"
          :error-messages="getError('chat_id')"
      ></v-text-field>
    </span>
    <v-checkbox
        v-model="chat.is_approve"
        :error="hasError('is_approve')"
        :error-messages="getError('is_approve')"
        label="Чат одобрен"
    ></v-checkbox>
  </scroll-center-dialog>
</template>

<script>
import FormErrorsMixin from "@/mixins/FormErrorsMixin"
import {mapActions} from "vuex";
import ScrollCenterDialog from "@/modules/templates/ScrollCenterDialog";
import PaginatedDataMapperMixin from "@/mixins/PaginatedDataMapperMixin";
import LoadingAutocomplete from "@/modules/core/components/LoadingAutocomplete";
import selectors from "@/urls/selectors";

export default {
  name: "ChatsEditDialog",
  props: {
    opened: Boolean,
    edit: Boolean,
    chatData: Object
  },
  mixins: [FormErrorsMixin, PaginatedDataMapperMixin],
  components: {
    ScrollCenterDialog,
    LoadingAutocomplete
  },
  data() {
    return {
      save_loading: false,
      chat_default: {
        user: "",
        chat_id: "",
        is_approve: true
      },
      chat: undefined
    }
  },
  computed: {
    form_title() {
      return this.edit === false ? "Добавить чат" : "Редактировать чат"
    },
    user_selector() {
      return selectors.SELECTORS.USERS.ALL()
    }
  },
  methods: {
    ...mapActions({
      createChats: "admin/createChats",
      changeChats: "admin/changeChats"
    }),
    close(){
      this.$emit("close", false)
    },
    loadChatsData(){
      if(this.chatData === undefined){
        this.chat = this.chat_default
      }
      else{
        this.chat = JSON.parse(JSON.stringify(this.chatData))
      }
    },
    save(){
      this.save_loading = true
      if (this.edit) {
        this.changeChats({
          id: this.chat.id,
          data: {is_approve: this.chat.is_approve},
          finalizer: (val) => {
            this.$emit("close", this.chat)
            this.save_loading = false
          },
          catcher:(val) => {
            this.mapErrors(val)
            this.save_loading = false
          }
        })
      }else {
        this.createChats({
          data: this.chat,
          finalizer: (val) => {
            this.$emit("close", this.chat)
            this.save_loading = false
          },
          catcher:(val) => {
            this.mapErrors(val)
            this.save_loading = false
          }
        })
      }
    }
  },
  created() {
    this.loadChatsData()
  }
}
</script>

<style scoped>

</style>
